import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { DomainMapping } from "../interfaces/DomainMapping";
import { DomainMappingPayload } from "../interfaces/DomainMappingPayload";

interface Props {
  onAuthError?: () => void;
}
export default class DomainMappingAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.UTP2_API}/api/DomainMappings`;

  getDomainMapping = async (customerId: number | undefined): Promise<DomainMapping[] | null> => {
    const data = await this.apiResponseHandler.get(`${DomainMappingAPIs.BASE_URL}/customers/${customerId}`);
    if (!data) {
      return null;
    }
    return data;
  };

  updateDomainMappings = async (domainMappings: DomainMappingPayload): Promise<number> => {
    const apiDomainMapping = `${DomainMappingAPIs.BASE_URL}/customers/${domainMappings.customerId}`;
    return await this.apiResponseHandler.put(apiDomainMapping, JSON.stringify(domainMappings.domainArray), false);
  };
}
